import messageCatalog from '~/shared/src/utilities/messageCatalog';
import User from '~/shared/src/model/User';

import {
    USER_SET,
    USER_UNSET,
    USER_CLONE
} from '../constants';
import {SetUserAction} from '~/frontend/src/actions/user/setUser';
import {UnsetUserAction} from '~/frontend/src/actions/user/unsetUser';
import {CloneUserAction} from '~/frontend/src/actions/user/cloneUser';
import {GlobalDataData} from '~/shared/src/model/GlobalData';

type SessionActions = SetUserAction | UnsetUserAction | CloneUserAction;

export type SessionState = Partial<{
    user : User | false
}>;

const relevantActions = [
    USER_SET,
    USER_UNSET,
    USER_CLONE
];


export default function sessionReducer( session : SessionState = {}, action : SessionActions ) : SessionState {
    if ( relevantActions.includes( action.type ) ) {
        session = session
            ? { ...session }
            : {};

        switch ( action.type ) {
            case USER_SET:
                session.user = new User( action.userData );

                // set users language
                messageCatalog.language = session.user.language;

                // set global user
                global.user = session.user;

                // set users application schema
                global.schema = session.user.application?.schema ?? global.defaultSchema;

                break;

            case USER_UNSET:
                session.user = false;

                delete global.user;
                global.schema = global.defaultSchema;
                global.data = {
                    default: {
                        items     : {},
                        references: {},
                        schema    : global.schema
                    }
                } as GlobalDataData;

                localStorage.clear();

                break;

            case USER_CLONE:
                if ( session.user ) {
                    session.user = session.user.clone();

                    // set users language
                    messageCatalog.language = session.user.language;

                    // set global user
                    global.user = session.user;

                    // set users application schema
                    global.schema = session.user.application?.schema ?? global.defaultSchema;
                }

                break;
        }
    }

    return session;
}
